import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store";

interface ISolarEstimationState {
  isShowEstimationInterruptModal: boolean;
  isOnConfirmPressed: boolean;
  isOnCancelPressed: boolean;
}

const defaultValues: ISolarEstimationState = {
  isShowEstimationInterruptModal: false,
  isOnConfirmPressed: false,
  isOnCancelPressed: false,
};

export const solarEstimationSlice = createSlice({
  name: "solarEstimation",
  initialState: { ...defaultValues },
  reducers: {
    setIsShowEstimationInterruptModal: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isShowEstimationInterruptModal = action.payload;
    },
    setIsOnConfirmPressed: (state, action: PayloadAction<boolean>) => {
      state.isOnConfirmPressed = action.payload;
    },
    setIsOnCancelPressed: (state, action: PayloadAction<boolean>) => {
      state.isOnCancelPressed = action.payload;
    },
  },
});

export const {
  setIsShowEstimationInterruptModal,
  setIsOnConfirmPressed,
  setIsOnCancelPressed,
} = solarEstimationSlice.actions;

export const selectIsShowEstimationInterruptModal = (state: RootState) =>
  state.solarEstimation.isShowEstimationInterruptModal;
export const selectIsOnConfirmPressed = (state: RootState) =>
  state.solarEstimation.isOnConfirmPressed;
export const selectIsOnCancelPressed = (state: RootState) =>
  state.solarEstimation.isOnCancelPressed;

export default solarEstimationSlice.reducer;
